/** Cascade-style brand loader used across the app. */
import { motion } from 'motion/react';

interface LoadingIconProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function LoadingIcon({ size = 'md', className = '' }: LoadingIconProps) {
  const config = {
    sm: { dot: 4, gap: 4, travel: 3 },
    md: { dot: 6, gap: 5, travel: 4 },
    lg: { dot: 8, gap: 6, travel: 5 },
  };
  const { dot, gap, travel } = config[size];
  const colors = ['#FF9B4A', '#FF856F', '#FF6EB1', '#C57CDF', '#8A6CF0'];

  return (
    <div
      className={`inline-flex items-end justify-center ${className}`}
      role="status"
      aria-live="polite"
      aria-label="Loading"
      style={{ gap }}
    >
      <span className="sr-only">Loading</span>
      {colors.map((color, index) => (
        <motion.span
          key={color}
          aria-hidden
          className="rounded-full"
          style={{
            width: dot,
            height: dot,
            backgroundColor: color,
          }}
          initial={{ y: 0, opacity: 0.35, scale: 0.9 }}
          animate={{
            y: [0, -travel, 0],
            opacity: [0.35, 1, 0.35],
            scale: [0.9, 1, 0.9],
          }}
          transition={{
            duration: 0.9,
            ease: 'easeInOut',
            repeat: Number.POSITIVE_INFINITY,
            delay: index * 0.1,
          }}
        />
      ))}
    </div>
  );
}
